<template>
  <skeleton theme="opacity" style="width:100%" shape="radius" bg-color="#dcdcdc">
    <v-layout row>
      <v-flex xs2>
        <div class="px-2" style="height: 46px">
          <tb-skeleton :aspect-ratio="1" shape="circle">
          </tb-skeleton>
        </div>
      </v-flex>
      <v-flex xs10>
        <div style="height: 89px;" class="pr-2">
          <v-layout align-start justify-start column fill-height>
            <div style="width: 100%">
              <v-layout>
                <v-flex xs6>
                  <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="100%"></tb-skeleton>
                </v-flex>
                <v-flex xs3></v-flex>
                <v-flex xs3>
                  <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="100%"></tb-skeleton>
                </v-flex>
              </v-layout>
            </div>
            <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px; margin-bottom: 5px" width="80%"></tb-skeleton>
            <tb-skeleton :aspect-ratio="0.1" style="padding-bottom: 19px" width="80%"></tb-skeleton>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </skeleton>
</template>

<script>
export default {
  name: "CustomerLoading"
}
</script>

<style scoped>

</style>
